import LocalStorage from "./LocalStorage"

export default class YoutubeApi {
}

YoutubeApi.apiReady = false
YoutubeApi.player = null;
YoutubeApi.divId = null;
YoutubeApi.videoId = null;
YoutubeApi.startTime = null;
YoutubeApi.endTime = null;
YoutubeApi.stepId = null;

YoutubeApi.setStepId = function (stepId) {
    this.stepId = stepId
}

YoutubeApi.setDivId = function (divId) {
    this.divId = divId
}

YoutubeApi.setVideoId = function (videoId) {
    this.videoId = videoId
}

YoutubeApi.setStartTime = function (startTime) {
    this.startTime = parseInt(startTime)
}

YoutubeApi.setEndTime = function (endTime) {
    this.endTime = parseInt(endTime)
}

function saveStartTimeOffset() {
    let offset = parseInt(YoutubeApi.player.getCurrentTime()) - parseInt(YoutubeApi.startTime);
    if (offset < 0) {
        offset = 0
    }
    LocalStorage.setMediaOffset(YoutubeApi.stepId, offset);
}

function onPlayerReady(event) {
    event.target.setVolume(100);

    const offset = LocalStorage.getMediaOffset(YoutubeApi.stepId)
    let startTime = YoutubeApi.startTime
    if (offset > 0) {
        startTime = startTime + offset
        event.target.seekTo(startTime);
    }
    // event.target.seekTo(newStartTime);
    // event.target.playVideo()
}

let timer;

function onPlayerStateChange(event) {
    if (event.data == 1) {//PLAYING
        const currentTime = parseInt(YoutubeApi.player.getCurrentTime()) + 1;
        if (
            currentTime < YoutubeApi.startTime
            || currentTime > YoutubeApi.endTime
        ) {
            event.target.seekTo(YoutubeApi.startTime)
        } else {
            timer = setInterval(saveStartTimeOffset, 1000)
        }

        let newEvent = new Event("youtube-playing");
        document.dispatchEvent(newEvent);
    } else if(event.data == 0) {// ENDED
        clearInterval(timer)
        LocalStorage.setMediaOffset(YoutubeApi.stepId, 0);
    } else {
        clearInterval(timer)
    }
}

YoutubeApi.renderVideo = function () {
    const offset = LocalStorage.getMediaOffset(YoutubeApi.stepId)
    let startTime = YoutubeApi.startTime
    if (offset > 0) {
        startTime = startTime + offset
    }

    if (this.apiReady && this.divId && this.videoId) {
        const w = 320;
        this.player = new YT.Player(this.divId, {
            width: w,
            height: w*9/16,
            videoId: this.videoId,
            host: 'https://www.youtube.com',
            playerVars: {
                autoplay: 0, // Auto-play the video on load
                controls: 0, // Show pause/play buttons in player
                showinfo: 0, // Hide the video title
                disablekb: 1, // Disable keyboard
                modestbranding: 1, // Hide the Youtube Logo
                fs: 0, // Hide the full screen button
                cc_load_policy: 0, // Hide closed captions
                iv_load_policy: 3, // Hide the Video Annotations
                start: startTime,
                end: YoutubeApi.endTime,
                autohide: 1, // Hide video controls when playing
                enablejsapi: 1
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange,
            }
        });
    }
}


// Loading Youtube Api and rendering video onReady
let tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
window.onYouTubeIframeAPIReady = function () {
    YoutubeApi.apiReady = true
    YoutubeApi.renderVideo()
}
